/**
 * @generated SignedSource<<05a3af097cad4af42e8031f985f99c7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamFragment$data = {
  readonly id: string;
  readonly accountId: string;
  readonly account: {
    readonly " $fragmentSpreads": FragmentRefs<"accountBaseFragment" | "accountDetailsFragment" | "accountAddressFragment">;
  };
  readonly members: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"teamMemberFragment">;
  }> | null;
  readonly " $fragmentType": "teamFragment";
};
export type teamFragment$key = {
  readonly " $data"?: teamFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"teamFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "teamFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "accountBaseFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "accountDetailsFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "accountAddressFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "members",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "teamMemberFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "6da5d201d0f0787ee7a82c9cf5d28f4e";

export default node;
